var initGoogleEvents = require('../services/google');
var eventMgr = require('../common/eventMgr');

/**
 * @description Set google autocomplete for the input value
 * @param {JQuery} input input to create events
 * @param {Object} config object of callback functions and params
 */
function setAutocomplete(input, config) {
    var autocompleteObject = {
        input: input[0]
    };

    if (config.countryRescriction) {
        autocompleteObject.options = {
            componentRestrictions: {
                country: config.countryRescriction || ''
            }
        };
    }

    eventMgr.execute('google.init.autocomplete', autocompleteObject).then((autocomplete) => {
        autocomplete.addListener('place_changed', () => {
            if (config.errorField) {
                config.errorField.html('');
            }
            var suggestResult = autocomplete.getPlace();
            if (suggestResult.address_components) {
                $('body').find('.store-page').data('components', suggestResult.address_components.length);

                config.handleAddress(suggestResult);
            } else {
                config.showGeolocatorError('notFoundError');
            }
        });
    });
}

/**
 * @description Set keydown event on enter press. Search for set data
 * @param {JQuery} input input to create events
 * @param {Object} config object of callback functions and params
 */
function setEnterHandling(input, config) {
    input.on('keydown', function (e) {
        if (e.key === 'Enter') {
            var value = $(this).val();
            if (value.trim().length > 2) {
                eventMgr.execute('google.geocode', {
                    value
                }).then((results) => {
                    if (config.errorField) {
                        config.errorField.html('');
                    }
                    if (results && results.length) {
                        $('body').find('.store-page').data('components', results[0].address_components.length);

                        eventMgr.execute('google.address.parse', results[0].address_components).then((parsedAddress) => {
                            config.handleAddress(parsedAddress, results[0].geometry);
                        });
                    }
                }).catch(() => {
                    config.showGeolocatorError('notFoundError');
                });
            }
        }
    });
}

/**
 * @description Creating My location handling for button
 * @param {JQuery} input input to create events
 * @param {Object} config object of callback functions and params
 */
function setMyLocationEvent(input, config) {
    config.myLocationBtn.on('click', (event) => {
        event.preventDefault();
        eventMgr.execute('google.get.user.location').then((results) => {
            if (results) {
                eventMgr.execute('google.geocode', results).then((address) => {
                    if (address.length) {
                        config.handleAddress(address[0]);
                        eventMgr.execute('google.address.parse', address[0].address_components).then((parsedAddress) => {
                            input.val(parsedAddress.postalCode || parsedAddress.address1);
                        });
                    }
                });
            }
        });
    });
}


/**
 * @description Add all handlers for autocomplete and my location button
 * @param {JQuery} input input to create events
 * @param {Object} config object of callback functions and params
 * @returns {Promise} promice object
 */
function setFunctionHandlers(input, config) {
    return eventMgr.execute('google.api', {
        apiKey: input.data('googleApi'),
        googleApiLibraries: 'places,geometry'
    }).then(() => {
        setAutocomplete(input, config);
        setEnterHandling(input, config);
        if (config.myLocationBtn) {
            setMyLocationEvent(input, config);
        }
        return Promise.resolve();
    });
}

module.exports = function (input, config) {
    return initGoogleEvents().then(() => {
        return setFunctionHandlers(input, config);
    });
};
